import {
  base_colorAction,
  base_colorAlert,
  base_colorAlertHover,
  grey100,
  grey400,
  grey500,
  notification_colorAlert,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { transition_fast } from 'ext-ui/style/transitionSpeeds'
import {
  font_family_weight_regular,
  font_md,
  font_sm,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  display: flex;
  flex-direction: column;
  &.medium {
    gap: ${spacing(2)};
  }
  &.small {
    gap: ${spacing(1)};
  }

  .label {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    color: ${text_colorTextSecondary};
    transition: color ${transition_fast};

    &.medium {
      gap: ${spacing(2)};
    }

    &.small {
      gap: ${spacing(1)};
    }

    &:hover,
    &.hovered {
      .textbox-container {
        border-color: ${grey500};

        &.disabled {
          border-color: ${grey400};
        }
      }
    }

    &:focus-within,
    &.focused {
      color: ${base_colorAction};

      .textbox-container {
        border-color: ${base_colorAction};
      }
    }

    &.error {
      color: ${base_colorAlert};

      &:hover,
      &.hovered {
        color: ${base_colorAlertHover};
      }

      .textbox-container {
        border-color: ${base_colorAlert};

        &:hover,
        &.hovered {
          border-color: ${base_colorAlertHover};
        }
      }
    }

    // CHILDREN

    & .label-field {
      display: flex;
      gap: ${spacing(1)};
      align-items: center;
      font-family: ${font_family_weight_regular};
      ${font_md};

      & .required-asterisk {
        color: ${base_colorAlert};
      }
    }
  }

  & .textbox-container {
    display: flex;
    align-items: flex-start;
    border: 1px solid ${grey400};
    background: ${grey100};
    gap: ${spacing(2)};
    transition:
      border-color ${transition_fast},
      opacity ${transition_fast};

    &.medium {
      padding: 0 ${spacing(5)};
      border-radius: ${spacing(2)};
    }

    &.small {
      padding: 0 ${spacing(2)};
      border-radius: ${spacing(1)};
    }

    &.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    & .textbox-icon {
      display: flex;
      align-items: center;
      justify-content: center;

      &.self-end {
        justify-self: flex-end;
      }

      &.small {
        min-width: ${spacing(4)};
        min-height: ${spacing(4)};
        margin-top: ${spacing(2)};
      }

      &.medium {
        min-width: ${spacing(6)};
        min-height: ${spacing(6)};
        margin-top: ${spacing(4)};
      }

      &.animation-container {
        position: relative;
      }
    }

    & .animation-icon-container {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  & .helper-text {
    color: ${text_colorTextSecondary};
    font-family: ${font_family_weight_regular};
    ${font_sm};
    &.medium {
      margin-left: ${spacing(5)};
    }
    &.small {
      margin-left: ${spacing(2)};
    }
  }

  & .error-text {
    display: flex;
    flex-direction: column;
    gap: ${spacing(1)};
    color: ${notification_colorAlert};
    font-family: ${font_family_weight_regular};
    ${font_sm};
  }
`
